import logoSvg from '@/assets/images/swiftaid-by-streeva-logo.svg?raw'

/** Swiftaid by Streeva wordmark for pdfmake `svg` nodes. */
export const SWIFTAID_LOGO_SVG = logoSvg.replace(/<\?xml[^>]*>/, '').trim()
